<div class="kt-portlet"
    [ngClass]="sidebarUI === 'true' ? 'chatbot-portlet-sidebar' : 'chatbot-portlet-main'"
    [ngStyle]="chatHistory.length < 1 && sidebarUI === 'false' ? { display:'flex', justifyContent:'center' } : {}">
    <!-- Header -->
    <div *ngIf="sidebarUI == 'true'" class="kt-portlet__head kt-portlet__head__custom chatbox-header">
        <div class="chatbot-head-label kt-portlet__head-label" style="flex: 0 0 46%;">
            <h3 class="kt-portlet__head-title"><span class="header-text">AI Expert Gen AI</span></h3>
        </div>
        <div class="kt-portlet__head-toolbar" #refTools [hidden]="false">
            <div class="chatbot-assets-tool-box">
                <button class="btn btn-with-icon" matTooltip="Open in New Tab" (click)="openInNewTab()">
                    <mat-icon>open_in_new</mat-icon>
                </button>
                <button class="btn btn-with-icon" matTooltip="Close" *ngIf="sidebarUI == 'true'" (click)="close()">
                    <i class="fa fa-times"></i>
                </button>
            </div>
        </div>
    </div>

    <!-- Body -->
    <div class="kt-portlet__body" [ngClass]="{'chatbot-sidebar-portlet__body': sidebarUI == 'true'}" #chatbotBody (scroll)="checkScrollPosition()">
        <div class="chatbox" [ngClass]="{'chatbox-sidebar': sidebarUI == 'true'}">
            <div class="circle-container" (click)="toggleRecognition()" *ngIf="isRecording"
                [ngClass]="{'active-mic': responseCounter>1}">
                <div class="circle">
                    <mat-icon class="ripple-mic">mic</mat-icon>
                </div>
                <div class="ripple" *ngIf="isRecording"></div>
            </div>
            <div class="chatbox-previews" [ngClass]="{'chatbox-previews-sidebar': sidebarUI == 'true'}"
                *ngIf="!chatHistory.length">
                <div class="welcome-message">
                    <div class="message-header" [ngClass]="{'chatbox-message-sidebar': sidebarUI == 'true'}">
                        How can I support you today?
                    </div>
                </div>
            </div>
            <!-- Chat Renders -->
            <div *ngIf="chatHistory.length" class="chatbox-messages"
                [ngClass]="{'messages-sidebar': sidebarUI == 'true'}" #chatMessageContainer (scroll)="checkScroll()">
                <div *ngFor="let chat of chatHistory; let i = index; let isLast = last">
                    <div [ngClass]="{
                                        'chat-message': isLast && !chat.isUser && responseCounter > 2,
                                        'chat-message-sidebar': isLast && !chat.isUser && responseCounter > 2 && sidebarUI === 'true',
                                        'response-block':!chat.isUser
                                      }">
                        <div class="uptime-version" *ngIf="!chat.isUser && !chat.modelChange && !hideThinking">
                            {{selectedChatbot.label == 'Inhouse GPT' ?'Inhouse GPT':'UptimeAI-1.1'}}
                            <span style="font-size:10px">{{getUpdatedTime(chat.id)}}</span>
                        </div>
                        <div *ngIf="!chat.modelChange" class="message"
                            [ngClass]="{'user': chat.isUser, 'chatbot': !chat.isUser, 'sideView': isMobileView || sidebarUI=='true'}">
                            <div class="bubble"
                                [ngClass]="{'user': chat.isUser, 'chatbot': !chat.isUser}">
                                <div *ngIf="!chat.isUser && !hideThinking">
                                    <div *ngIf="chatHistory[chat.id - 1]?.thoughts" class="reasoning-header header-nav">
                                        <div *ngIf="chatHistory[chat.id - 1]?.thoughts?.animating && !chatHistory[chat.id-1].responsesAnimated; else showTime">
                                            <img src="../../../../../assets/media/icons/timer-loader.gif" height="24px"
                                                width="24px" alt="Loading" />
                                            <span>Thinking</span>
                                        </div>
                                        <mat-icon *ngIf="chatHistory[chat.id - 1]?.thoughts && chatHistory[chat.id - 1]?.thoughts?.text?.length" (click)="toggleExpand(chat.id)" class="dropdown-arrow">
                                            {{ !chatHistory[chat.id-1].thoughts?.show ?
                                            'arrow_drop_down':'arrow_drop_up'}}
                                        </mat-icon>
                                    </div>
                                    <ng-template #showTime>
                                        <div>
                                            Thought for {{ chatHistory[chat.id - 1]?.time_taken?.toFixed(2) }}s
                                        </div>
                                    </ng-template>
                                </div>
                                <div *ngIf="chatHistory[chat.id-1]?.thoughts?.show" class="chat-bubble" [@slideInOut]>
                                    <div class="chat-content">
                                        <!-- Render animated text character by character -->
                                        <markdown class="chatbot-text" style="color:#00000080;" ngPreserveWhitespaces
                                            [data]="chatHistory[chat.id-1].thoughts?.animatedText"></markdown>
                                    </div>
                                </div>
                                <div *ngIf="!chat.isUser" class="chatbot-text" [innerHTML]="chat.text"></div>
                                <div *ngIf="chat.isUser" class="chatbot-text user-message">
                                    <div *ngIf="chat.isUser && chat.files?.length" class="user-message">
                                        <div class="file-preview-item" *ngFor="let file of chat.files; let j = index">
                                            <div class="file-icon" [ngStyle]="{'background-color': getBackgroundColor(file)}">
                                                <mat-icon fontSet="material-symbols-rounded" class="file-icon-image">{{ getFileIcon(file) }}</mat-icon>
                                            </div>
                                            <div class="file-name" [matTooltip]="file.name">{{ file.displayedName }}</div>
                                        </div>
                                    </div>
                                    <div class=" user-bubble" [innerHTML]="chat.text"></div>
                                </div>
                                <div *ngIf="!chat.isUser && chat.model_type == 'RAG'">
                                    <div style="font-style: italic;">References:</div>
                                    <div *ngFor="let r of chat.references">
                                        <a href="{{r.url}}" target="_blank">{{r.url.substring(r.url.lastIndexOf('/')
                                            +1)}}</a>
                                    </div>
                                </div>
                                <ng-container *ngIf="chat.data">
                                    <ng-container
                                        *ngTemplateOutlet="chatResponseTemplate; context: { $implicit: chat }"></ng-container>
                                </ng-container>
                            </div>
                        </div>
                        <div class="graph" *ngIf="chat.graphData?.length">
                            <div [id]="'chatbot-'+ i" class="graph-container"></div>
                        </div>
                        <div class="notice" *ngIf="chat.modelChange">
                            <div class="separator"></div>
                            <div class="model-change-text">{{chat.text}}</div>
                            <div class="separator"></div>
                        </div>
                    </div>
                </div>
                <div *ngIf="showScrollIcon || scrollable" class="scroll-down-icon"
                    (click)="scrollToBottom()">
                    <mat-icon class="down-icon">arrow_downward</mat-icon>
                </div>
                <div *ngIf="textLoading" class="message response-block chatbot delayed-element" [ngClass]="{
                                    'chat-message': responseCounter > 2,
                                    'chat-message-sidebar': responseCounter > 2 && sidebarUI === 'true'
                                  }">
                    <div class="uptime-version">
                        {{ !hideThinking ? (selectedChatbot.label == 'Inhouse GPT' ? 'Inhouse GPT' : 'UptimeAI-1.1') : 'Analysing' }}
                        <span *ngIf="!hideThinking" style="font-size:10px;">{{ getUpdatedTime() }}</span>
                      </div>
                    <div class="thinking">
                        <div *ngIf="!hideThinking" class="reasoning-header header-nav">
                            <img src="../../../../../assets/media/icons/timer-loader.gif" height="24px" width="24px"
                                alt="">
                            <span class="thinking-title">Thinking</span>
                            <mat-icon class="dropdown-arrow">arrow_drop_up</mat-icon>
                        </div>
                        <img class="loading-bubble" src="../../../../../assets/media/icons/AI loader.gif" alt="">
                    </div>
                </div>
            </div>

            <!-- Input Box -->
            <div #inputbox *ngIf="!isSharedChat" class="chatbox-input" [ngClass]="[responseCounter ? 'fix-chatbot-input' : '',
                sidebarUI === 'true' ? 'chatbox-input-sidebar' : 'chatbox-input-mainpage']">
                <div class="file-preview-container" [style.height]="dynamicHeight" *ngIf="uploadedFiles.length > 0">
                    <div class="file-preview-item" *ngFor="let file of uploadedFiles; let i = index">
                        <div class="file-icon" [ngStyle]="{'background-color': getBackgroundColor(file)}">
                            <mat-icon *ngIf="file.progress==100" fontSet="material-symbols-rounded" class="file-icon-image">{{ getFileIcon(file) }}</mat-icon>
                            <mat-progress-spinner *ngIf="file.progress < 100 && !file.uploadFailed" class="file-progress-spinner"
                                mode="determinate" [value]="file.progress" diameter="15" strokeWidth="2">
                            </mat-progress-spinner>
                        </div>
                        <div class="file-name" [matTooltip]="file.name">{{ file.displayedName }}</div>
                        <div class="cancel-icon" (click)="removeFile(i)">
                            <mat-icon fontSet="material-symbols-rounded" class="file-icon-image">cancel</mat-icon>
                        </div>
                    </div>
                </div>
                <textarea #userInput [(ngModel)]="userMessage" (input)="adjustHeight()"
                    (keyup.enter)="enableSendButton && !isFileUploading && getBotResponse()"
                    placeholder="Ask AI a question or make a request..." class="chatbox-textarea"></textarea>
                <div class="action-botton">
                    <div class="action-icons">
                        <mat-icon *ngIf="showUpload && chatbotFolderUrl" class="attach-file chatbot-icon-margin"
                            matTooltip="Upload File" (click)="fileInput.click()"> attach_file</mat-icon>
                        <mat-icon *ngIf="speechSupported" class="attach-file chatbot-icon-margin no-focus-outline"
                            matTooltip="Ask something"
                            [ngClass]="{'mic-icon-active': isRecording,'mic-disabled': !enableSendButton}" tabindex="0"
                            #startButton (keyup.enter)="enableSendButton && !isFileUploading && getBotResponse()"
                            (click)="toggleRecognition()">mic_none</mat-icon>
                        <mat-icon class="attach-file" style="font-size: 24px !important;"
                            [matTooltip]="getLanguageToolTipText()" [matMenuTriggerFor]="menu">language</mat-icon>
                        <mat-menu #menu="matMenu" xPosition="after">
                            <button mat-menu-item *ngFor="let language of supportedLanguageList; let i = index"
                                (click)="selectLanguage(i)" style="font-weight:400"
                                [ngClass]="{'selected-language': selectedLanguage === language}">{{language.name}}</button>
                        </mat-menu>
                        <input #fileInput type="file" style="display: none" (change)="handleFileUpload($event)"
                            onclick="this.value=null;" [accept]="acceptedFileTypes" multiple>
                    </div>
                    <div class="chatbot-dropdown">
                        <div class="chatbot-dropdown-head">
                            <mat-form-field class="chatbot-form-field-box mat-form-field-fluid">
                                <mat-select disableOptionCentering="true"  [disabled]="textLoading" (selectionChange)="toggleChatbot($event)"
                                    [(ngModel)]="selectedChatbot" class="mat-select-bot">
                                    <mat-option *ngFor="let option of chatbotOptions" [value]="option" [matTooltip]="option.label">{{
                                        option.label}}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <mat-icon class="send-btn chatbot-icon-margin" (click)="getBotResponse()"
                            [class.disabled]="!enableSendButton || isFileUploading || isUserMessage()"
                            [ngClass]="{'disabled-icon': !enableSendButton || isFileUploading || isUserMessage()}">arrow_upward</mat-icon>
                    </div>
                </div>
            </div>
            <div #hideBottomGap class="bottom-gap-filler"></div>
        </div>
    </div>
</div>

<!-- Markdown Renders -->
<ng-template #chatResponseTemplate let-chat>
    <div style="position:relative" *ngFor="let response of chat.data let isLast = last">
        <!-- Text Rendering -->
        <div *ngIf="chat.responsesAnimated" class="response-container">
            <div style="width:100%" *ngIf="response.type === 'text'">
                <markdown class="chatbot-text markdown-wrapper" ngPreserveWhitespaces [data]="response.animate ? response.animatedData : response.data"></markdown>
                <div *ngIf="response.metadata?.length && chatHistory[chat.id-1]?.feedBack?.showSupportDoc"
                    class="references-container">
                    <div class="reference-text">Support docs:</div>
                    <div class="references-list">
                        <div *ngFor="let reference of response.metadata" class="reference-item">
                            <mat-icon class="doc-icon">description</mat-icon>
                            <a class="reference-item-text" [href]="reference.url" target="_blank">
                                <span [matTooltip]="getUrl(reference.url)">{{ showTitle(getUrl(reference.url)) }}</span>
                                <span class="page-no" *ngIf="reference.page">(Page{{" "+reference.page}})</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Table Rendering -->
            <kt-chatbot-table style="width:100%" *ngIf="response.type === 'table' && (chatHistory?.length === chat?.id ? showChild : true)" [dataSource]="response.data" [sidebarUI]="sidebarUI" [mobileView]="isMobileView"></kt-chatbot-table>

            <!-- Image Rendering -->
            <div class="image-container" *ngIf="response.type === 'image'"
                [ngClass]="{'image-sidebar': sidebarUI == 'true'}">
                <img class="response-image" [src]="getImageLink(response.data)"
                    (click)="openImage(getImageLink(response.data))" alt="Image not Loaded" />
                <div class="icon-wrapper">
                    <i class="flaticon-arrows .text-dark-25 icon-xs expand-button" style="color:#BEC0C3"
                        (click)="openImage(getImageLink(response.data))"></i>
                </div>
            </div>

            <div *ngIf="response.type === 'plotly' && (chatHistory?.length === chat?.id ? showChild : true)" class="plotly-response">
                <kt-chat-graph [data]="response.data"></kt-chat-graph>
            </div>

            <div *ngIf="isLast && chatHistory[chat.id - 1]?.feedBack && chatHistory[chat.id - 1]?.feedBack['showFeedBack']" class="utils">
                <img *ngIf="isLLMModelSelected" class="feedback-icon"
                    [src]="chatHistory[chat.id-1].feedBack?.outlinedLikedIcon ? 'assets/media/icons/Share 3.svg' : 'assets/media/icons/Share 6.svg'"
                    (click)="toggleLike(chat.id)" [matTooltip]="'Good Response'" alt="Like">
                <img *ngIf="isLLMModelSelected" class="feedback-icon"
                [ngStyle]="{
                    'pointer-events': isDislikePopupOpen ? 'none' : 'auto',
                    'cursor': isDislikePopupOpen ? 'default' : 'pointer',
                    'opacity': isDislikePopupOpen ? '0.4' : '1'
                  }"
                    [src]="chatHistory[chat.id-1].feedBack?.outlinedDisLikedIcon ? 'assets/media/icons/Share 4.svg' : 'assets/media/icons/Group 7.svg'"
                    (click)="toggleDislike(chat.id)" [matTooltip]="'Bad Response'" alt="Dislike Icon">
                <img class="feedback-icon" (click)="readChat(chat.id)"
                    [matTooltip]="chatHistory[chat.id-1].feedBack?.isReading ? 'Stop reading' : 'Read'"
                    [src]="chatHistory[chat.id-1].feedBack?.isReading ? 'assets/media/icons/stop_circle.svg' : 'assets/media/icons/hearing.svg'"
                    alt="">
                <img *ngIf="isLLMModelSelected" (click)="shareChatHistory(chat.id)" class="feedback-icon" [matTooltip]="'share'"
                    [src]="'assets/media/icons/Share 2.svg'" alt="">
                <img class="feedback-icon" (click)="copyToClipboard(chat.id)"
                    [matTooltip]="chatHistory[chat.id-1].feedBack?.isCopied ? 'Copied' : 'Copy'"
                    [src]="chatHistory[chat.id-1].feedBack?.isCopied ? 'assets/media/icons/done.svg' : 'assets/media/icons/content_copy.svg'"
                    alt="Copy Icon">
            </div>
        </div>
        <!-- FeedBack Page -->
        <div *ngIf="isLast && chatHistory[chat.id-1]?.feedBack?.openFeedbackBox" class="feedback-container" [ngStyle]="{
                    'width': sidebarUI == 'true' ? '320px' : '505px',
                    'position': chatHistory.length==chat.id ? 'relative' : 'absolute'
                  }">
            <div class="header">
                Tell us more:<span class="close-icon" (click)="closeFeedback(chat.id)"><mat-icon>close</mat-icon></span>
            </div>
            <div class="feedback-buttons" [ngClass]="{'feedback-button-sidebar': sidebarUI == 'true'}">
                <button class="feedback-button" (click)="selectFeedback(chat.id,1)">Not factually correct</button>
                <button class="feedback-button" (click)="selectFeedback(chat.id,2)">Didn't fully follow
                    instructions</button>
                <button class="feedback-button" (click)="selectFeedback(chat.id,3)" [ngClass]="{'selectedFeedback':selectedFeedback}">Others</button>
            </div>
            <input *ngIf="chatHistory[chat.id-1].feedBack?.showTextarea" placeholder="Feel free to add specific details"
                [(ngModel)]="description" class="description-area" [ngStyle]="{
                border: isFocused ? '1px solid blue' : '1px solid blue',
                outline: 'none'}" (focus)="isFocused = true" (blur)="isFocused = false" />
            <div *ngIf="chatHistory[chat.id-1].feedBack?.showTextarea" class="submit-feedback">
                <button mat-raised-button class="submit-button-genai"
                    style="background-color: #EEEEF7;color:#252525;margin-right:16px;"
                    (click)="cancelFeedback(chat.id)">Cancel</button>
                <button mat-raised-button class="submit-button-genai" style="background-color: #000000;color:white"
                    [disabled]="!this.description?.length"
                    [ngStyle]="{'background-color': !this.description?.length ? '#BEC0C3' : '#000000'}"
                    (click)="submitFeedback(chat.id)">Submit</button>
            </div>
        </div>
        <div *ngIf="response.followUps?.length && chatHistory[chat.id-1]?.feedBack?.showSupportDoc" class="follow-up">
            <div class="follow-up-header">Follow Up</div>
            <div *ngFor="let followUp of response.followUps;let index=index;let isLast=last"
                (click)="getFollowUpResponse(followUp)">
                <div class="follow-up-item">
                    <mat-icon>subdirectory_arrow_right</mat-icon>
                    <div class="follow-up-text">{{followUp}}</div>
                </div>
                <mat-list *ngIf="!isLast">
                    <mat-divider></mat-divider>
                </mat-list>
            </div>
        </div>
    </div>
</ng-template>